export default __webpack_public_path__ + "static/Logotype-53ecf00bb6d9e7ebd0d7ba55b4508311.png";